import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { PRODUCTS } from '../data/products';
import { useReveal } from '../hooks/useReveal';
import './ProductDetail.css';

function Section({ section, index }) {
  return (
    <article className="detail-panel reveal" style={{ transitionDelay: `${index * 0.07}s` }}>
      <h2 className="panel-title">{section.title}</h2>
      {section.text && <p className="panel-text">{section.text}</p>}
      {section.list && (
        <ul className="panel-list">
          {section.list.map((item, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </ul>
      )}
      {section.ordered && (
        <ol className="panel-olist">
          {section.ordered.map((item, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </ol>
      )}
    </article>
  );
}

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const revealRef = useReveal();
  const product = PRODUCTS.find(p => p.id === id);

  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, [id]);

  if (!product) {
    return (
      <div className="detail-wrap container">
        <button className="detail-back" onClick={() => navigate('/')}>← Back to Products</button>
        <p style={{ color: 'var(--muted)' }}>Product not found.</p>
      </div>
    );
  }

  return (
    <div className="detail-wrap container fade-up" ref={revealRef}>
      <button className="detail-back" onClick={() => { navigate('/'); setTimeout(() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' }), 300); }}>
        ← Back to Products
      </button>

      {/* Header */}
      <div className="detail-header">
        <div className="detail-header-top">
          <span className="detail-emoji">{product.emoji}</span>
          <div>
            <h1 className="detail-h1">{product.name}</h1>
            <p className="detail-tagline">{product.tagline}</p>
          </div>
        </div>
        {/* Feature chips */}
        <div className="detail-chips">
          {product.points.map((pt, i) => (
            <span key={i} className="detail-chip">{pt}</span>
          ))}
        </div>
      </div>

      {/* Panels */}
      <div className="detail-panels">
        {product.sections.map((section, i) => (
          <Section key={i} section={section} index={i} />
        ))}
      </div>

      {/* CTA */}
      <div className="detail-cta">
        <a
          className="btn-gold demo-btn"
          href={`mailto:info@visiontechnoservices.com?subject=Demo Request – ${encodeURIComponent(product.name)}&body=I would like to request a demo for ${encodeURIComponent(product.name)}.`}
        >
          🚀 Request a Demo
        </a>
        <button className="btn-outline" onClick={() => { navigate('/products')}}>
          View All Products
        </button>
      </div>
    </div>
  );
}
